(() => {
  const root = document.querySelector('[data-sjd-currency-converter]');
  if (!root) return;

  const select = root.querySelector('[data-sjd-currency-select]');
  const notice = root.querySelector('[data-sjd-currency-notice]');
  if (!(select instanceof HTMLSelectElement)) return;

  const rates = {
    USD: Number(root.dataset.sjdRateUsd) || 1,
    GBP: Number(root.dataset.sjdRateGbp) || 0.747063,
    EUR: Number(root.dataset.sjdRateEur) || 0.876691,
    NGN: Number(root.dataset.sjdRateNgn) || 1377.172985,
    GHS: Number(root.dataset.sjdRateGhs) || 11.594989,
  };
  const storageKey = 'sjd-display-currency';
  const priceSelector = '[data-sjd-money], .sjd-product-summary__price, .price, .compare-at-price, [data-cart-subtotal]';
  const usdValuePattern = /(?:US\s*)?\$\s?([0-9][0-9,]*(?:\.[0-9]{1,2})?)/g;
  let activeCurrency = getStoredCurrency() || getPathCurrency();
  let scheduled = false;

  if (!rates[activeCurrency]) activeCurrency = 'USD';
  select.value = activeCurrency;

  function getStoredCurrency() {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return saved && rates[saved] ? saved : null;
    } catch (error) {
      return null;
    }
  }

  function getPathCurrency() {
    const path = window.location.pathname;
    if (path.startsWith('/en-gb/')) return 'GBP';
    if (path.startsWith('/en-eu/')) return 'EUR';
    return 'USD';
  }

  function parseUsdCents(value) {
    const number = Number(String(value).replace(/,/g, ''));
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function formatUsdCents(cents) {
    const fractionDigits = activeCurrency === 'NGN' ? 0 : 2;
    return new Intl.NumberFormat('en', {
      style: 'currency',
      currency: activeCurrency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format((cents / 100) * rates[activeCurrency]);
  }

  function renderPrice(element) {
    if (!(element instanceof HTMLElement)) return;
    if (element.dataset.sjdRenderedCurrency === activeCurrency) return;

    const explicitCents = element.dataset.sjdMoney;
    let rendered = '';

    if (explicitCents !== undefined && explicitCents !== '') {
      const cents = Number(explicitCents);
      if (!Number.isFinite(cents)) return;
      rendered = formatUsdCents(cents);
    } else {
      const template = element.dataset.sjdUsdTemplate || element.textContent || '';
      const matches = [...template.matchAll(usdValuePattern)];
      if (!matches.length) return;

      element.dataset.sjdUsdTemplate = template;
      rendered = template.replace(usdValuePattern, (match, amount) => {
        const cents = parseUsdCents(amount);
        return cents === null ? match : formatUsdCents(cents);
      });
    }

    element.textContent = rendered;
    element.dataset.sjdRenderedCurrency = activeCurrency;
    element.dataset.sjdRenderedText = rendered.trim();
  }

  function renderAll(scope = document) {
    const elements = scope.querySelectorAll ? scope.querySelectorAll(priceSelector) : [];
    elements.forEach(renderPrice);
    const isReferenceCurrency = activeCurrency !== 'USD';
    notice.hidden = !isReferenceCurrency;
    root.classList.toggle('is-reference-active', isReferenceCurrency);
  }

  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      renderAll();
    });
  }

  select.addEventListener('change', () => {
    activeCurrency = rates[select.value] ? select.value : 'USD';
    try {
      window.localStorage.setItem(storageKey, activeCurrency);
    } catch (error) {
      // The converter still works when the browser blocks local storage.
    }

    document.querySelectorAll(priceSelector).forEach((element) => {
      delete element.dataset.sjdRenderedCurrency;
    });
    renderAll();
  });

  const observer = new MutationObserver((mutations) => {
    let hasPriceChange = false;

    mutations.forEach((mutation) => {
      const target = mutation.target instanceof HTMLElement ? mutation.target : mutation.target.parentElement;
      const priceElement = target?.closest(priceSelector);
      if (priceElement) {
        hasPriceChange = true;
        if (priceElement.dataset.sjdRenderedText !== priceElement.textContent.trim()) {
          delete priceElement.dataset.sjdUsdTemplate;
          delete priceElement.dataset.sjdRenderedCurrency;
        }
      }

      if (Array.from(mutation.addedNodes).some((node) => node instanceof Element && (node.matches(priceSelector) || node.querySelector(priceSelector)))) {
        hasPriceChange = true;
      }
    });

    if (hasPriceChange) scheduleRender();
  });

  renderAll();
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();